import { ChangeDetectorRef, Component, ElementRef, Inject, Renderer2 } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { SplittingService } from './modules/spliting.service';
import { SplittedService } from './modules/splited.service';
import { ClassifyService } from '../project-editing/modules/classify.service';
import config from 'config/default.json';
import { DialogComponent } from '../../dialog/dialog.component';

@Component({
  selector: 'app-project-spliting',
  templateUrl: './project-spliting.component.html',
  styleUrls: ['./project-spliting.component.scss'],
  providers: [SplittingService, SplittedService, ClassifyService]
})
export class ProjectSplitingComponent {
  constructor(
    
    public dialogRef: MatDialogRef<ProjectSplitingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { [x:string]: any },
    private renderer: Renderer2,
    private elRef: ElementRef,
    private cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    private apiService: ApiServiceModule,
    public dialog: MatDialog,
    public sanitizer: DomSanitizer,
    public splittingService: SplittingService,
    public splittedService: SplittedService,
    public classifyService: ClassifyService,
    
    ) {}
    PDFJS = (window as { [key: string]: any })["pdfjs-dist/build/pdf"];
    userInfos: {[x: string]: any} = this.data['user_infos'];
    projectInfos: {[x: string]: any} = this.data['project'];
    rawData: {[x: string]: any}[] = this.data['raw_data'];
    contentData: { [x:string]: any }[] = this.data['content_data'];
    classifyData: { [x:string]: any }[] = this.data['classify_data'];
    platformInfos: { [x:string]: any } = this.data['platform_infos'];
    isEpanel: boolean = false;
    externalDataContent: any;


    inProgress = false;

    splittingActive = false;
    splittedActive = false;
    classifiedActive = false;
    currentTask = ''
    taskLabels:{[x: string]: any}= {
      'task-splitting': 'Content Splitter',
      'task-splitted': 'Content Splitted',
      'task-classified': 'Content Classification'
    }
    showExternalContent = false;


    ngOnInit(){
      this.splittingService.init(this);
      this.splittedService.init(this);
      this.classifyService.init(this);
      this.isEpanel = this.platformInfos['origin'] == 'epanel';

      this.currentTask = this.projectInfos['last_task'];
      if(this.currentTask == 'task-splitting') this.splittingService.showSplitting();
      if(this.currentTask == 'task-splitted') this.splittedService.showSplitted();
      if(this.currentTask == 'task-classified') this.classifyService.showClassified(); 
  
    }
    buildProcess(){
      if(this.splittingActive) this.splittingService.computeSplit();
      if(this.splittedActive) this.splittedService.computeAutoClassification();
    }
    moveNextPageExternalContent(){

    }
    loadExternalContent(rowInfos:any){
      this.helper.showToast('Load external contents...');
      this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/raw-content/load_project_external_content', {raw_infos: rowInfos, project_infos: this.projectInfos, platform_infos: this.platformInfos}, this.userInfos['access_token']).subscribe((response:any)=>{
        
        let externalUrls = response.map((element:any)=>({id_content: element.id_content, url: this.platformInfos['root']+'/'+element.url}));

        this.helper.showToast('Loaded!');
        this.externalDataContent = {
          action: 'show-content',
          source: 'service', 
          page_origin: 'add-content-spliting', 
          show_mode: 'pdf-show', 
          file_urls: externalUrls, 
          docx_file: '', 
          user_infos: this.userInfos
        }
        if(externalUrls.length > 0) this.showExternalContent = true;
      });
      
    }
    callBackEventEmiter(idContent:any){
      const dialogRef = this.dialog.open(DialogComponent, {
        width: '50%',
        position: {top: '30px' },
        data: {page: 'confirmation', text: `You are about to add the content ${idContent} to this project. Continue ?`}
      });
      dialogRef.afterClosed().subscribe((toContinue:boolean) => {
        if(toContinue){
          this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/raw-content/add_project_external_content', {id_raw: idContent, project_infos: this.projectInfos, platform_infos: this.platformInfos}, this.userInfos['access_token']).subscribe((response:any)=>{
          this.helper.showToast(response.message);
          });
        }
      });
    
  }
    closeExternal(value:any) {
      this.showExternalContent = value;
    }

    onClose(): void {
      this.dialogRef.close();
    }
    activatePage(page:string){
      this.currentTask = page;
      this.splittingActive = this.currentTask == 'task-splitting'? true: false;
      this.splittedActive = this.currentTask == 'task-splitted'? true: false;
      this.classifiedActive = this.currentTask == 'task-classified'? true: false;
      this.cdRef.detectChanges();

    }
    removeChildsFromElement(element:any){
      while (element.hasChildNodes()){
        element.removeChild(element.lastChild);
      }
    }
}
